import NavLink2 from "../compnents/NavLink2";
import Team from "../images/team.png";
import Footer4 from "../compnents/Footer4";
import Footer5 from "../compnents/Footer5";
import { Col, Container, Row } from "react-bootstrap";


const PrivacyPolicy = () => {


  return (
    <div className="privacy-policy-page">
      <div
        className="main-MF"
        style={{
          backgroundImage: `url(${Team})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          height: "150px",
          textAlign: "center",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)"
        }}
      >
        <div>
          <NavLink2 />
          <h1>Privacy Policy</h1>
        </div>
      </div>
      <Container fluid className="policy pt-3 pb-5 px-5 ">
        <div className="policy-content w-max-w-6xl mx-auto">
          <h4 className="text-dark-blue mt-2 fw-bold">PRIVACY MATTERS.</h4>
          <p className="text-p">
            {" "}
            We know that data privacy is an important issue today, and we want you
            to enjoy your interaction with us whilst knowing that we value your
            Personal Data and that we protect it.
            <br />
            <br />
            Here, you will find an overview of how we process your Personal Data,
            the purposes for which we process it, and how you benefit. You’ll also
            see what your rights are and how you can contact us.
            <br />
            <br />
            Our website is available for visiting and enquiry and also our
            visitors who is interested in receiving our newsletters and updates.
            <br />
            <br />
            This is an online Privacy Policy that explains in details what we
            require, how we collect, use, share and protect our customers personal
            details and our visitors who visit our site for more enquires of our
            products and services.
            <br />
            <br />
            As a TrustBanc Financial Group customer, be guaranteed that we keep
            our trust as we protect your vital and personal information.
            <br />
            <br />
            TrustBanc Financial Group customers have the leverage to make
            decisions of how their personal information may be used and shared as
            we encourage our clients to make choices that enables us to provide
            excellent products and services that aids to meet your financial
            needs.
            <br />
            <br />
          </p>
          <h4 className="text-dark-blue fw-bold">SECURITY OF PRIVATE INFORMATION</h4>
          <p className="text-p">
            {" "}
            Protecting your private information is our priority as such,we
            maintain physical and electronic protection that complies with the
            federal law directives, which obligate us to ensure your information
            is protected from unlawful access and use, alterations and destruction
            and other unpredicted illegal processing.
            <br />
            <br />
            We participate in continuous training of our staff in the adequate
            management of personal information, when we use other organizations to
            provide services, we require them to guard the confidentiality of our
            client’s personal information they received from us.
            <br />
            <br />
            At TrustBanc Financial Group, we take information privacy extremely
            important, as we provide our customers with satisfactory security to
            protect such personal information from unlawful access. It is required
            that any third party who renders services on our behalf to comply with
            compliance values to guard our client’s information.
            <br />
            <br /> We are delighted to declare that we comply with international
            best practices and requirements.
            <br />
            <br />
          </p>
          <h4 className="text-dark-blue fw-bold">THE INFORMATION WE COLLECT</h4>
          TrustBanc Financial Group will solemnly collect information necessary in
          relations to transactions with relevant rules and regulations.
          <br />
          <br />
          <h4 className="text-dark-blue fw-bold">HOW DO WE COLLECT INFORMATION?</h4>
          <p>
            {" "}
            TrustBanc Financial Group gathers information from different sources
            and it may relate to any of our products or services we render which
            includes;
          </p>
          <ul className="tw-list-disc">
            <li>Opening of any account or completion of any transactions.</li>
            <li>Application for loans.</li>
            <li>Sourcing for investments.</li>
            <li>
              When you call our customer service desk for a complain and
              disputes.
            </li>
            <li>
              Information regarding your credit history from credit bureaus.
            </li>
            <li>
              Provision of account information such as; name, gender, date of
              birth, address, mobile numbers and work address.
            </li>
            <li>
              Provision of personal identity such as; photo ID, passport
              information, National ID card and nationality
            </li>
            <li>
              Usage of private logins for online transactions and mobile banking
              apps
            </li>
            <li>
              We carry out due diligence checks and obtain information that we
              need to support our regulatory obligations, e.g. information about
              transaction details, detection of any suspicious and unusual
              activities.
            </li>
          </ul>

          <h4 className="text-dark-blue fw-bold">HOW WE USE YOUR INFORMATION</h4>

          {" "}
          <ul className="tw-list-disc">
            <li>
              TrustBanc Financial Group uses the information provided and
              authorized by our customers.
            </li>
            <li>
              We use the information collected to provide adequate and swift
              services as we manage our business and render outstanding customer
              services.
            </li>

            <li>
              We use this information to detect and prevent financial crimes
              including fraud, financing for terrorism and money laundering,
              this is to ensure security and business continuity.
            </li>
            <li>
              Information are used to meet compliance obligations, to comply
              with rules and regulations and to share with regulators when
              required.
            </li>
            <li>
              We may send you information via email or mobile number, regarding
              your account or your transactions.
            </li>
            <li>
              We may reach you through phone calls, letters, emails, WhatsApp
              chats and it may be recorded for instructions references and to
              improve our products and services.
            </li>
          </ul>

          <h4 className="text-dark-blue fw-bold">WHO WE SHARE YOUR INFORMATION WITH?</h4>
          <p>
            {" "}
            We may share your information only when we have consent and approval
            to do so,as well as when we have to met regulators requirements
            <br />
            <br />
          </p>
          <h4 className="text-dark-blue fw-bold">
            WHAT ARE YOUR RIGHTS OVER YOUR PERSONAL INFORMATION?
          </h4>
          <ul className="tw-list-disc">
            <li>
              <b>RIGHT OF INDIVIDUALITY –</b>
              <br />
              When asked to provide any personal or private information, you
              will be informed of the reason for the request and why it is
              necessary.
            </li>
            <br />

            <li>
              <b>RIGHT OF PERSONAL ACCESS – </b>Individuals have the right to
              access personal and finacial information.
            </li>
            <br />
            <li>
              <b> RIGHT TO SUSPENSION – </b>Individuals have the right to
              suspend, withdraw and process their information at any given time
              as we are allowed to store the personal information for future
              access.
            </li>
            <br />
            <li>
              <b> RIGHT TO DELETION –</b> Individuals have the right to request
              for cancellation and deletion their personal information where
              there is no compelling legal or regulatory obligation for its
              continued processing.
            </li>
            <br />
            <li>
              <b>RIGHT TO DATA MOVABILITY – </b>We will ensure that personal
              data is moved, copied or transferred easily from one IT
              environment to another in a safe and secure way, without
              interference to usability.
            </li>
            <br />
            <li>
              <b>RIGHT OF OBJECTION – </b>Individuals have the right to object
              to our dispensation of their information in some conditions.
            </li>
          </ul>
          <p>
            Questions, comments and requests regarding this privacy policy are welcomed and should be addressed to
            <a href="mailto:tbamdpo@trustbancgroup.com"> tbamdpo@trustbancgroup.com</a> or telephone: <a href="tel:07031128020">07031128020</a>
            <br />
            <br />
            To contact our Data Protection Officer, kindly address your request to “The Data Protection Officer” at 163, Sinari Daranijo Street, Off Ligali Ayorinde, Victoria Island, Lagos, Nigeria.
            <br />
            <br />
            <b>Note: </b>This Privacy Policy may be updated periodically.
          </p>
        </div>
      </Container>
      <div>
        <Footer5 />
      </div>
      <div className="footer-4">
        <Footer4 />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
